import { isIOS, realResizeEvent, } from "../utilities/globalUtilities";
import { TEXTAREA_SCROLL_STEP } from "../utilities/constants";
import { hasScrollbar } from "../utilities/globalUtilities";

const debounce = require("lodash/debounce");
const $document = $(document);
const $body = $("body");

const $cache = {
    window: $(window)
};

let windowWidth = $cache.window.width();

const selectEvents = () => {
    $document.find("select").click(function () {
        if (!window?.mqRespond?.status?.tablet && !window?.mqRespond?.status?.mobile) {
            $(this).next(".search-arrow").toggleClass("opened");
        }
    });

    $body.click(function (e) {
        if (!$(e.target).is("select") && $(".search-arrow.opened").length) {
            $(".search-arrow").removeClass("opened");
        }
    });

    $document.on("keyup", e => {
        if (e.key == "Escape") {
            $(".search-arrow").removeClass("opened");
        }
    });
};

/**
* @function
* @description - Function reused for label animation event listeners
* @param {Element} e - Passed event
*/
const inputAnimation = e => {
    if (e.type === "touchend" && isIOS()) {
        e.stopImmediatePropagation();
    }
    const $this = $(e.currentTarget);
    const isSecondary = $this.hasClass("pwc-form-input--secondary");
    const $label = $this.siblings(".ct-form-label--secondary");

    if ($this.hasClass("filled") && $this.val() == "" && e.type === "focusout") {
        $this.removeClass("filled");

        if (isSecondary) {
            $label.text($label.data("primary-label"));
        }
    } else {
        if (e.type != "focusout" && e.type != "touchend") {
            $this.addClass("filled");

            if (isSecondary) {
                $label.text($label.data("secondary-label"));
            }
        } else {
            if (isSecondary) {
                $label.text($label.data("primary-label"));
            }
        }
    }

    if (e.type === "focusout") {
        $(".pwc-form-input[data-toggle='tooltip']").tooltip("hide");
    }
};

/**
* @function
* @description - Define event listeners for label animation
*/
const inputAnimationEvents = () => {
    document.querySelectorAll(".label-animation .pwc-form-input").forEach(element => {
        element.addEventListener("focusin", inputAnimation);
        element.addEventListener("focusout", inputAnimation);
        element.addEventListener("touchend", inputAnimation);
    });
};

/**
* @function
* @description - Reinitialize the input animation event only for a given element
* @param {Element} $element - The element to be initialized
*/
const reinitInputAnimationEvent = $element => {
    $element.on("focusin focusout", e => {
        let $this = $(e.target);

        $this.toggleClass("filled", !$this.hasClass("filled") && $this.val() != "");
    });
};

const focusOutEventIOS = () => {
    $body.on("touchend", e => {
        if (isIOS()) {
            const activeElement = document.activeElement;
            const targetElement = e.currentTarget;
            const formElements = ["input", "select", "textarea"];

            if (activeElement != targetElement && targetElement.tagName.toLowerCase() === "body" && formElements.includes(activeElement.tagName.toLowerCase())) {
                activeElement.blur();
                activeElement.classList.toggle("filled", activeElement.value != "");
            }
        }
    });
};

/**
* errors generated on client side validation, without ajax call
* @param {Object} form - form.
* @param {Object} element - element that contains error that will be shown.
*/

const showError = (form, element) => {
    form.find(element).removeClass("d-none");
    form.find(".form-control").addClass("is-invalid");
};

/**
* @function
* @description - Initialize input delete/submit overlay buttons events
* @param {String} inputID - input ID attribute
*/
const initInputOverlayButtons = (inputID, saveEmpty = false) => {
    const inputElement = document.querySelector(inputID);

    if (!inputElement) { return; }

    const inputDeleteBtn = inputElement.closest(".js-form-group").querySelector(".pwc-input-delete-btn");

    inputElement.addEventListener("keyup", e => {
        const inputTarget = e.target;

        if (!saveEmpty) {
            inputTarget.closest(".js-form-group").querySelectorAll(".pwc-input-btn").forEach(btn => {
                btn.classList.toggle("d-none", inputTarget.value == "");
            });
        }
    });

    inputElement.addEventListener("focusout", debounce(e => {
        const inputTarget = e.target;

        inputTarget.closest(".js-form-group").querySelectorAll(".pwc-input-btn").forEach(btn => btn.classList.add("d-none"));
    }, 200));

    inputElement.addEventListener("focusin", e => {
        const inputTarget = e.currentTarget;

        if (inputTarget.value !== "" || saveEmpty) {
            inputTarget.closest(".js-form-group").querySelectorAll(".pwc-input-btn").forEach(btn => btn.classList.remove("d-none"));
        }
    });

    inputDeleteBtn.addEventListener("click", e => {
        const currentTarget = e.currentTarget;
        inputElement.value = "";
        inputElement.classList.remove("filled");

        currentTarget.closest(".js-form-group").querySelectorAll(".pwc-input-btn").forEach(btn => {
            btn.classList.add("d-none");
        });
    });
};

/**
* Enable/disable scroll up and down textarea button
*/
const checkTextareaScrollbar = () => {
    document.querySelectorAll(".pwc-textarea").forEach(element => {
        element.addEventListener("keyup", e => {
            const target = e.currentTarget;
            const textareaScrollBtns = document.querySelectorAll(".pwc-textarea-scroll-btn");

            textareaScrollBtns.forEach(elem => {
                if (hasScrollbar(target)) {
                    elem.removeAttribute("disabled");
                } else {
                    elem.setAttribute("disabled", "disabled");
                }
            });
        });
    });
};

/**
* Initialize textarea manual scroll events
*/
const initTextareaScroll = () => {
    const textarea = document.querySelector(".pwc-textarea");
    const scrollUpBtn = document.querySelector(".pwc-textarea-scroll-up");
    const scrollDownBtn = document.querySelector(".pwc-textarea-scroll-down");

    if (!scrollUpBtn || !scrollDownBtn) { return; }

    scrollUpBtn.addEventListener("click", e => {
        e.preventDefault();

        // Scroll up
        $(textarea).animate({
            scrollTop: "-=" + TEXTAREA_SCROLL_STEP + "px"
        });
    });

    scrollDownBtn.addEventListener("click", e => {
        e.preventDefault();

        // Scroll down
        $(textarea).animate({
            scrollTop: "+=" + TEXTAREA_SCROLL_STEP + "px"
        });
    });
};

const init = () => {
    selectEvents();
    inputAnimationEvents();
    focusOutEventIOS();
    checkTextareaScrollbar();
    initTextareaScroll();

    $cache.window.on("resize", debounce(() => {
        if (!realResizeEvent(windowWidth)) { return; }

        windowWidth = $cache.window.width();
    }, 200));
};

export {
    init,
    inputAnimationEvents,
    reinitInputAnimationEvent,
    showError,
    initInputOverlayButtons,
    selectEvents,
    checkTextareaScrollbar,
    initTextareaScroll
};
